// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"2079":"DashboardPageView","4956":"ProjectOptimizationView"}[chunkId] + "." + {"2079":"8e71bb42","4956":"1ad2a5e6"}[chunkId] + ".chunk.css";
};